import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import PdfViewer from '../pdf-viewer/PdfViewer';
import Logo from '../_shared/Logo';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';

const HEADER_HEIGHT = 64;

const PdfReaderPage: React.FC = () => {
  const context = useContext(ApplicationContext);
  const translatorService: ITranslatorService = (context as AppContext).translatorService;

  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [title, setTitle] = useState('PDF Document');

  useEffect(() => {
    const stored = sessionStorage.getItem('pdfViewerState');
    if (stored) {
      try {
        const { blobUrl, title: storedTitle } = JSON.parse(stored);
        setPdfUrl(blobUrl);
        if (storedTitle) setTitle(storedTitle);
      } catch {
        console.error('Failed to parse pdfViewerState from sessionStorage');
      }
    }
  }, []);

  if (!pdfUrl) {
    return (
      <Box
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h5" color="textSecondary">
          {translatorService.Tranlate(
            'FLEET_NO_FILE_ASSOCIATED_WITH_DOCUMENT_ERROR_TEXT',
            'No file associated with document'
          )}
        </Typography>
      </Box>
    );
  }

  return (
    <Box style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box
        style={{
          height: HEADER_HEIGHT,
          minHeight: HEADER_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e0e0e0',
          position: 'relative'
        }}
      >
        <Logo height={56} />
        <Typography variant="h5" style={{ width: '100%', textAlign: 'center', fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
      <Box style={{ flexGrow: 1, overflow: 'hidden' }}>
        <PdfViewer pdfUrl={pdfUrl} height="100%" title={title} />
      </Box>
    </Box>
  );
};

export default PdfReaderPage;
